// extracted by mini-css-extract-plugin
export var required = "_fo-0";